import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { GraduationCap, Award, FolderOpen, Clock } from 'lucide-react';
import { mockTeam } from '../mock';

const Team = () => {
  const { t } = useTranslation();

  return (
    <section id="equipo" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('team.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('team.description')}
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTeam.map((member) => (
            <Card key={member.id} className="bg-gray-900 border-gray-700 hover:border-red-500 transition-all duration-300 hover:shadow-xl group">
              <CardHeader className="text-center">
                {/* Profile Image */}
                <div className="relative mx-auto mb-4">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-32 h-32 rounded-full object-cover border-4 border-red-500 group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute -bottom-2 -right-2 bg-red-600 text-white p-2 rounded-full">
                    <Award className="w-4 h-4" />
                  </div>
                </div>

                <CardTitle className="text-2xl text-white group-hover:text-red-500 transition-colors duration-300">
                  {member.name}
                </CardTitle>
                <CardDescription className="text-red-500 font-semibold text-lg">
                  {t(member.title)}
                </CardDescription>
              </CardHeader>

              <CardContent className="space-y-4">
                {/* Details Grid */}
                <div className="space-y-3">
                  <div className="flex items-center space-x-3 text-gray-300">
                    <Clock className="w-5 h-5 text-red-500 flex-shrink-0" />
                    <span className="text-sm">
                      <span className="font-semibold">{member.experience}</span> {t('team.experience')}
                    </span>
                  </div>

                  <div className="flex items-center space-x-3 text-gray-300">
                    <GraduationCap className="w-5 h-5 text-red-500 flex-shrink-0" />
                    <span className="text-sm">{t(member.education)}</span>
                  </div>

                  <div className="flex items-center space-x-3 text-gray-300">
                    <FolderOpen className="w-5 h-5 text-red-500 flex-shrink-0" />
                    <span className="text-sm">
                      <span className="font-semibold">{member.projects}</span> {t('team.projects')}
                    </span>
                  </div>
                </div>

              </CardContent>
            </Card>
          ))}
        </div>

        {/* Team CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-red-600/20 to-red-600/10 border border-red-600/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              {t('team.cta.title')}
            </h3>
            <p className="text-gray-300 mb-6 text-lg">
              {t('team.cta.description')}
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-2xl mx-auto">
              <div className="text-center">
                <div className="text-2xl font-bold text-red-500">40+</div>
                <div className="text-sm text-gray-400">{t('team.cta.stats.experience')}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-red-500">370+</div>
                <div className="text-sm text-gray-400">{t('team.cta.stats.projects')}</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-red-500">100%</div>
                <div className="text-sm text-gray-400">{t('team.cta.stats.success')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;